import { combineReducers } from 'redux';

import getTeamReq from './get-team-req';

export default combineReducers({
  getTeamReq,
});



// WEBPACK FOOTER //
// ./src/redux/teams/index.js